import type { JPDExperience } from '@jira/polaris__lib-analytics/src/ExperienceMetadataExtra.types.tsx';
import { isAbortableError } from '@atlassian/jira-fetch/src/utils/is-abortable-error.tsx';

// isAbortableError excludes all client errors
export const wrapWithAbortableExperience = <R,>(
	experience: JPDExperience,
	callback: () => Promise<R>,
): Promise<R> => {
	experience.start();
	return callback()
		.then((result) => {
			experience.success();
			return result;
		})
		.catch((err: unknown) => {
			const error: Error =
				err instanceof Error ? err : new Error('Error during experience', { cause: err });
			if (isAbortableError(error)) {
				experience.abort(error);
				throw err;
			}
			experience.failure(error);
			throw err;
		});
};
